{
	"eventsTitle": "Events",
	"timestampTitle": "Timestamp",
	"eventTypeTitle": "Event type",
	"transactionIdTitle": "Transaction ID",
	"invoiceNumberTitle": "Invoice number",
	"carbonReductionsTitle": "Carbon reductions (kg CO₂)",
	"detailsTitle": "Details",
	"viewOnHashscan": "View transaction on HashScan",
	"viewAdjustmentDetails": "View adjustment details",
	"paginationTitle": "View items per page",
	"clearAllFilters": "Clear all filters",
	"fetchError": "Could not load the plant events. Please try again.",
	"eventTypes": {
		"Deposit": "Deposit",
		"Withdrawal": "Withdrawal",
		"BufferAdjustment": "Buffer adjustment",
		"BalanceAdjustment": "Balance adjustment"
	},
	"adjustmentModal": {
		"bufferTitle": "{{plant}} {{year}} – Carbon buffer adjustment",
		"balanceTitle": "{{plant}} {{year}} – Carbon balance adjustment",
		"bufferField": "Carbon buffer setting",
		"fossilAmount": "Fossil amount (kg CO₂)",
		"biogenicAmount": "Biogenic amount (kg CO₂)",
		"remainingFossilBuffer": "Remaining fossil buffer (kg CO₂)",
		"remainingBiogenicBuffer": "Remaining biogenic buffer (kg CO₂)",
		"editor": "Editor",
		"reason": "Reason for adjustment",
		"close": "Close"
	}
}
